import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { useAuth } from './context/auth.context';
import useApiFetch from './hooks/useApiFetch';
const CrossIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
        <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M18 6L6 18M6 6l12 12"
        />
    </svg>
);

const MessageIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
        <path
            d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const TestWidget = () => {
    const [open, setOpen] = useState(false);
    const [token] = useState(Cookies.get('access_token'));
    const { currentUser } = useAuth();
    const orgId = currentUser?.organization?.codeName;
    const [unreadCount, setUnreadCount] = useState(0);

    const TestWidgetSource = process.env.REACT_APP_TEST_WIDGET_SOURCE || 'http://localhost:3001/test';

    const previewWidgetIframeHtml = `<!DOCTYPE html>
    <html>
      <head>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1 viewport-fit=cover, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <style>
          body { margin: 0; }
          #chat-root {
            height: 100vh;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
          }
          html { overflow: hidden; }
          @media (max-width: 1023px) {
            html, body, #chat-root {
              width: 100vw !important;
              height: 100vh !important;
              border-radius: 0 !important;
            }
          }
        </style>
        <link rel="stylesheet" href="${TestWidgetSource}/styles.css" />
      </head>
      <body>
        <div id="chat-root"></div>
        <script src="${TestWidgetSource}/test.js"></script>
      </body>
    </html>`;

    // Listen for messages from iframe (like "new message")
    //   useEffect(() => {
    //     const handler = (event) => {
    //       if (event.data?.type === "commkraft_chat_message") {
    //         setUnreadCount((prev) => prev + 1);
    //         if (!open) {
    //           const audio = new Audio(
    //             `${process.env.REACT_APP_WIDGET_HOST || TestWidgetSource}/notification.mp3`
    //           );
    //           audio.play().catch(() => {});
    //         }
    //       }
    //     };
    //     window.addEventListener("message", handler);
    //     return () => window.removeEventListener("message", handler);
    //   }, [open]);

    // Reset unread when opened
    const {
        data: botProfile,
        // loading: loadingBotProfile,
        // refetch: loadBotPofile,
    } = useApiFetch('/api/bot-profile', (data) => data?.data?.[0]);

    useEffect(() => {
        if (open) setUnreadCount(0);
    }, [open]);

    return (
        <>
            {/* Floating Button */}
            {/* Floating Button */}
            <button
                onClick={() => setOpen(!open)}
                disabled={!botProfile?.activated} // disable when not active
                style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    width: '50px',
                    height: '50px',
                    borderRadius: '50%',
                    border: 'none',
                    backgroundColor: botProfile?.activated ? '#1677ff' : '#ccc', // blue if active, grey if not
                    color: '#fff',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    cursor: botProfile?.activated ? 'pointer' : 'not-allowed', // show not-allowed cursor
                    zIndex: 1000,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    opacity: botProfile?.activated ? 1 : 0.6, // little faded if inactive
                }}
            >
                {open ? <CrossIcon /> : <MessageIcon />}
                {unreadCount > 0 && !open && botProfile?.activated && (
                    <span
                        style={{
                            position: 'absolute',
                            top: '8px',
                            right: '8px',
                            minWidth: '15px',
                            height: '18px',
                            borderRadius: '50%',
                            backgroundColor: 'orange',
                            color: '#fff',
                            fontSize: '12px',
                            fontWeight: 'bold',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '0 2px',
                        }}
                    >
                        {unreadCount}
                    </span>
                )}
            </button>

            {/* Iframe Popup */}
            {open && (
                <iframe
                    title="Widget Test"
                    id="widget-test"
                    srcDoc={previewWidgetIframeHtml}
                    style={{
                        position: 'fixed',
                        bottom: '90px',
                        right: '20px',
                        width: window.innerWidth < 1024 ? '100%' : '400px',
                        height: window.innerWidth < 1024 ? '100%' : '600px',
                        border: '1px solid #ddd',
                        borderRadius: window.innerWidth < 1024 ? '0' : '12px',
                        boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
                        zIndex: 1000,
                    }}
                    onLoad={() => {
                        const iframe = document.getElementById('widget-test');
                        if (iframe?.contentWindow) {
                            iframe.contentWindow.postMessage({ type: 'auth-token', token }, '*');
                            iframe.contentWindow.postMessage({ type: 'org-id', orgId }, '*');
                        }
                    }}
                />
            )}
        </>
    );
};

export default TestWidget;
